import moment from 'moment'
import {
  getBodyHeightValue,
  getAddressValue,
  getPharmacyAddressValue,
  getPhoneNumberValue,
} from '../../../utils/common'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { ALLERGY_TEXT, SEVERITY_TEXT } from '../../../utils/constants'

export const text = {
  FIRST_NAME: 'First name:',
  PREFERRED_NAME: 'Preferred name:',
  LAST_NAME: 'Last name:',
  DOB: 'DOB:',
  DOB_WITH_FORMAT: 'DOB (MM/DD/YYYY)*',
  PERSONAL: 'Personal',
  EMERGENCY_CONTACT: 'Emergency contact',
  RELATIONSHIP_TO_PATIENT: 'Relationship to patient:',
  PHONE: 'Phone:',
  CONTACT: 'Contact',
  EMAIL: 'Email:',
  STREET_ADDRESS: 'Street address:',
  PREFERRED_PHARMACY: 'Preferred pharmacy:',
  COMPLETED_ON: 'Completed on:',
  VISIT_TYPE: 'Visit type:',
  LAST_UPDATE: 'Last updated:',
  BODY_MEASUREMENTS: 'Body measurements',
  HEIGHT: 'Height:',
  WEIGHT: 'Weight:',
  IDENTITY: 'Identity',
  MARITAL_STATUS: 'Marital status:',
  SEX_AT_BIRTH: 'Sex at birth:',
  GENDER_IDENTITY: 'Gender identity:',
  RACIAL_BACKGROUND: 'Racial background:',
  ACCOUNT_INFORMATION: 'Account information',
  PRESCRIPTIONS: 'Prescriptions',
  ORDERS: 'Prescriptions',
  PAST_VISITS: 'Past visits',
  UPCOMING_VISITS: 'Upcoming visits',
  GENERAL_INFORMATION: 'General information',
  NO_PAST_VISITS: 'No past visits',
  NO_UPCOMING_VISITS: 'No upcoming visits',
  PATIENT: 'Patient:',
  EDIT: 'Edit',
  SAVE: 'Save',
  HEIGHT_FT: 'height (ft)',
  INTAKE_FORMS: 'Intake forms',
  MARITAL_STATUS_LOWER: 'marital status',
  RACIAL_BACKGROUND_LOWER: 'racial background',
  GENDER_IDENTITY_LOWER: 'gender identity',
  PHONE_NUMBER: 'phone number',
  PLEASE_FILL_ALL_FIELDS: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  FIELD_REQUIRED_ALLERGY_ERROR: getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, ALLERGY_TEXT),
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  FIELD_REQUIRED_SEVERITY_ERROR: getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, SEVERITY_TEXT),
  ALLERGY_UNIQUE_ERROR: getUserFriendlyErrorMessage(errorCodes.ALLERGY_NAME_NOT_UNIQUE),
  ALLERGY_VALIDATION_ERROR: getUserFriendlyErrorMessage(errorCodes.ONLY_NUMBERS_AND_LETTERS_ALLOWED),
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMaritalValue = (value) => {
  switch (value) {
    case 'annulled':
      return 'Annulled'
    case 'divorced':
      return 'Divorced'
    case 'legallyseparated':
      return 'Legally separated'
    case 'married':
      return 'Married'
    case 'polygamous':
      return 'Polygamous'
    case 'nevermarried':
      return 'Never married'
    case 'domesticpartner':
      return 'Domestic partner'
    case 'single':
      return 'Single'
    case 'widowed':
      return 'Widowed'
    case 'prefernottosay':
      return 'Prefer not to say'
    default:
      return ''
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMaritalEnum = (value) => {
  switch (value) {
    case 'Annulled':
      return 'annulled'
    case 'Divorced':
      return 'divorced'
    case 'Legally separated':
      return 'legallyseparated'
    case 'Married':
      return 'married'
    case 'Polygamous':
      return 'polygamous'
    case 'Never married':
      return 'nevermarried'
    case 'Domestic partner':
      return 'domesticpartner'
    case 'Single':
      return 'single'
    case 'Widowed':
      return 'widowed'
    case 'Prefer not to say':
      return 'prefernottosay'
    default:
      return ''
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getRacialValue = (value) => {
  switch (value) {
    case 'americanindianalaskanative':
      return 'American Indian or Alaska Native'
    case 'asian':
      return 'Asian'
    case 'blackafricanamerican':
      return 'Black or African American'
    case 'caucasian':
      return 'Caucasian'
    case 'hispaniclatino':
      return 'Hispanic or Latino'
    case 'nativehawaiianpacificislander':
      return 'Native Hawaiian or other Pacific Islander'
    case 'prefernottosay':
      return 'Prefer not to say'
    default:
      return ''
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getRacialEnum = (value) => {
  switch (value) {
    case 'American Indian or Alaska Native':
      return 'americanindianalaskanative'
    case 'Asian':
      return 'asian'
    case 'Black or African American':
      return 'blackafricanamerican'
    case 'Caucasian':
      return 'caucasian'
    case 'Hispanic or Latino':
      return 'hispaniclatino'
    case 'Native Hawaiian or other Pacific Islander':
      return 'nativehawaiianpacificislander'
    case 'Prefer not to say':
      return 'prefernottosay'
    default:
      return ''
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const accountInfo = (patient, type) => {
  switch (type) {
    case text.PERSONAL:
      return [
        { text: `${text.FIRST_NAME} ${patient.FirstName}`, value: patient.FirstName },
        { text: `${text.LAST_NAME} ${patient.LastName}`, value: patient.LastName },
        {
          text: `${text.PREFERRED_NAME} ${patient.PreferredName || '--'}`,
          value: patient.PreferredName || '--',
        },
        { text: `${text.DOB} ${moment(patient.BirthDate).format('MM/DD/YYYY')}`, value: patient.DOB },
      ]
    case text.CONTACT:
      return [
        {
          text: `${text.PHONE} ${getPhoneNumberValue(patient.PhoneNumber?.Prefix, patient.PhoneNumber?.Number)}`,
          value: patient.PhoneNumber?.Number,
        },
        { text: `${text.EMAIL} ${patient.Email}`, value: patient.Email },
        {
          text: `${text.STREET_ADDRESS} ${getAddressValue(patient.Address) || '--'}`,
          value: getAddressValue(patient.Address) || '--',
        },
        {
          text: `${text.PREFERRED_PHARMACY} ${getPharmacyAddressValue(patient?.Pharmacy) || '--'}`,
          value: getPharmacyAddressValue(patient?.Pharmacy) || '--',
        },
      ]
    case text.EMERGENCY_CONTACT:
      return [
        {
          text: `${text.FIRST_NAME} ${patient?.EmergencyContact?.FirstName || '--'}`,
          value: patient?.EmergencyContact?.FirstName || '--',
        },
        {
          text: `${text.LAST_NAME} ${patient?.EmergencyContact?.LastName || '--'}`,
          value: patient?.EmergencyContact?.LastName || '--',
        },
        {
          text: `${text.RELATIONSHIP_TO_PATIENT} ${patient?.EmergencyContact?.Relationship || '--'}`,
          value: patient?.EmergencyContact?.Relationship || '--',
        },
        {
          text: `${text.PHONE} ${
            getPhoneNumberValue(
              patient?.EmergencyContact?.PhoneNumber?.Prefix,
              patient?.EmergencyContact?.PhoneNumber?.Number,
            ) || '--'
          }`,
          value: patient?.EmergencyContact?.PhoneNumber?.Number || '--',
        },
      ]
    case text.BODY_MEASUREMENTS:
      return [
        {
          text: `${text.HEIGHT} ${getBodyHeightValue(patient?.HeightInches) || '--'}`,
          value: getBodyHeightValue(patient?.HeightInches) || '--',
        },
        {
          text: `${text.WEIGHT} ${patient?.WeightPounds ? `${patient?.WeightPounds} lbs` : '--'}`,
          value: patient?.WeightPounds || '--',
        },
      ]
    case text.IDENTITY:
      return [
        {
          text: `${text.MARITAL_STATUS} ${getMaritalValue(patient?.MaritalStatus) || '--'}`,
          value: getMaritalValue(patient?.MaritalStatus) || '--',
        },
        {
          text: `${text.SEX_AT_BIRTH} ${patient?.Gender?.[0]?.toUpperCase() + patient?.Gender?.slice(1) || '--'}`,
          value: patient?.Gender?.[0]?.toUpperCase() + patient?.Gender?.slice(1) || '--',
        },
        {
          text: `${text.GENDER_IDENTITY} ${patient?.GenderIdentity || '--'}`,
          value: patient?.GenderIdentity || '--',
        },
        {
          text: `${text.RACIAL_BACKGROUND} ${getRacialValue(patient?.RacialBackground) || '--'}`,
          value: getRacialValue(patient?.RacialBackground) || '--',
        },
      ]
    case text.LAST_UPDATE:
      return patient?.AccountInfoUpdateDateTime ?? '--'
    case text.INTAKE_FORMS:
      // eslint-disable-next-line no-case-declarations
      const completed = moment(patient.CompleteDateTime).format('MMM DD YYYY')

      return [
        {
          value: patient?.Name || '--',
          text: patient?.Name || '--',
          textClassName: 'patient-chart-bold-first-row',
        },
        {
          value: completed || '--',
          text: `${text.COMPLETED_ON} ${completed || '--'}`,
        },
        {
          value: patient?.VisitTypeName || '--',
          text: `${text.VISIT_TYPE} ${patient?.VisitTypeName || '--'}`,
        },
      ]
    default:
      break
  }
}

export const FILES_COUNT = 20

export const accountOnHoldIndicatorsText = {
  ACCOUNT_ON_HOLD: 'Account on hold',
  PATIENT_ACCOUNT_IS_ON_HOLD: 'This patient’s account is on hold.',
}
export const TAG_OPTIONS = [
  { value: 'DiagnosticTests', isActive: false },
  { value: 'DrugScreen', isActive: false },
  { value: 'Insurance', isActive: false },
  { value: 'LabResults', isActive: false },
  { value: 'OBOT', isActive: false },
  { value: 'Correspondence', isActive: false },
  { value: 'Forms', isActive: false },
  { value: 'PDMP', isActive: false },
  { value: 'CounselingVerification', isActive: false },
  { value: 'IDVerified', isActive: false },
  { value: 'FrontOfID', isActive: false },
  { value: 'BackOfID', isActive: false },
  { value: 'Other', isActive: false },
]
export const multiSelectDropdownStyles = {
  width: 442,
}

export const dropdownContainerStyle = {
  top: 68,
  right: 0,
}
